<style scoped>
.color-panel-item {
  padding-left: 5px;
  padding-right: 5px;
}
.color-panel-label {
  text-align: center;
}
.tag-item {
  float: left;
  margin: 4px;
}
</style>

<template>

<div class="component-wrapper">
  <mu-card>
    <mu-flex justify-content="center" fill>
      <b>{{tagTemplate.name}}</b>
    </mu-flex>
    <div class="clearfix" />
    <tag-item
      v-for="(tag, index) in tagTemplate.tags"
      class="tag-item"
      :key="index"
      :tag="tag"
      />
    <div class="clearfix" />
    <mu-card-actions>
      <mu-button icon @click="onActionApplyTemplate" v-tooltip="$t('tagTemplate.apply')"><mu-icon value="input" /></mu-button>
      <mu-button icon @click="flagDialogDelete = true" v-tooltip="$t('button.delete')"><mu-icon value="delete" /></mu-button>
    </mu-card-actions>
  </mu-card>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('tagTemplate.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="onCancelDelete"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Library
import axios from "axios";

// Components
import TagItem from '@/components/Tag/TagItem.vue'

export default {
  name: 'TagTemplateItem',
  components: {
    TagItem
  },
  props: {
    tagTemplate: {
      type: Object,
      required: true
    },
    mediaId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      // Flag
      flagDialogDelete: false, // Boolean variable for status of delete dialog
    }
  },
  computed: {
    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.tagTemplate.name });
    },

    // Constant
    constTrue() {
      return true;
    },
    constFalse() {
      return false;
    },
  },
  methods: {
    // Event
    onClickDelete() {
      this.flagDialogDelete = true;
      this.flagDialogEdit = false;
    },
    onCancelDelete() {
      this.flagDialogDelete = false;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "tagTemplate/" + this.tagTemplate._id, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'ids': this.attachmentIds
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.delete'));
      });
    },

    onActionApplyTemplate() {
      this.flagDialogApplyTemplate = false;
      axios.post(this.$store.getters.urlApi + "tagTemplate/" + this.tagTemplate._id, {
        'media': this.mediaId,
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.create'));
      });
    },
  },

}
</script>
